var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"honorBox"},_vm._l((_vm.honorUrls),function(item,index){return _c('img',{key:index,class:[_vm.honorselect === index ? 'honorActive' : 'honorImg'],attrs:{"src":item},on:{"click":function($event){return _vm.imghonor(index)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1196a3d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftAside/digital_industry/companyInformation/menu3.vue
// module id = null
// module chunks = 